<footer>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    fxLayoutAlign.gt-xs="space-between center"
    class="footer-content"
  >
    <a
      fxLayout="row"
      fxLayoutAlign="space-between center"
      [routerLink]="basePath"
      class="footer-item"
    >
      <img
        [src]="agencyService.agency.logo.url ? agencyService.agency.logo.url : '/assets/icons/logo_footer.svg'"
        [alt]="agencyService.agency.name"
        class="logo-footer"
      >
    </a>
    <div
      *ngIf="agencyService.agency.social_footer_visibility == true"
      fxLayout="column"
      fxLayoutAlign="center center"
      class="footer-item"
    >
      <h6>
        Social Media:
      </h6>
      <app-social-icons-base [isTooltipBelow]="false"></app-social-icons-base>
    </div>
    <a
      fxLayout="column"
      fxLayoutAlign="center center"
      class="developed-by-section footer-item"
      href="https://vaunt.ro/"
      target="_blank"
    >
      <h6>
        Website dezvoltat de:
      </h6>
      <img
        src="/assets/icons/vaunt_logo.svg"
        alt="logo vaunt"
        class="logo-vaunt"
      >
    </a>
  </div>
</footer>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/footer-vaunt/footer-vaunt.component.html